import { GetIssueResponseDto, useApi } from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

export function useIssue(
  code: string | undefined,
): UseQueryResult<GetIssueResponseDto, ExtendedAxiosError> {
  const api = useApi();

  return useQuery<GetIssueResponseDto, ExtendedAxiosError>({
    queryKey: ['issues', code],
    queryFn: async () =>
      // Because of the "enabled" option, code is always defined here
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      api.issuesApi.getIssue(code!).then((r) => r.data),
    enabled: !!code,
    staleTime: 3600,
  });
}
